import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { UploadPicker } from "../../UploadPicker";

export function OwnNarration({ book, onDone }) {
  const vid = book.approved_version_id || book.current_version_id;
  const [chapters, setChapters] = useState([]);
  const [ch, setCh] = useState("");
  useEffect(() => { if (vid) api.get(`/books/${book.id}/versions/${vid}`).then((r) => { setChapters(r.data.chapters); setCh(r.data.chapters[0]?.id || ""); }).catch(() => {}); }, [book.id, vid]);
  return (
    <div className="panel p-5 space-y-3" data-testid="own-narration">
      <p className="eyebrow">Your own narration</p>
      {!vid ? <p className="text-xs text-slate-400">Import a manuscript first so recordings can be matched to chapters.</p> : (
        <>
          <p className="text-xs text-slate-400">Attach a recording from your uploads to a chapter. It gets the same audio checks, review and mastering as AI tracks.</p>
          <select value={ch} onChange={(e) => setCh(e.target.value)} className="w-full h-9 rounded-md bg-slate-900 border border-slate-700 px-2 text-sm" data-testid="own-narration-chapter">
            {chapters.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}
          </select>
          <UploadPicker kind="audio" label="Choose recording from my uploads" disabled={!ch} testId="own-narration-pick" className="w-full justify-center h-9"
            onPick={async (u) => { await api.post(`/books/${book.id}/chapter-audio/from-upload`, { upload_id: u.id, chapter_id: ch }); toast.success("Recording added to the chapter"); onDone(); }} />
        </>
      )}
    </div>
  );
}
